import React, { useEffect, useState } from "react";

import "./Quick.scss"
import { messageFill, MessageFillResult } from "../../api/chat";

type Content = {
  id: number;
  content: string;
}

type QuickProps = {
  onConfirm: (value: string)=> void;
}

const Quick: React.FC<QuickProps> = (props)=> {

  const [visible, setVisible] = useState(false)

  const [list, setList] = useState<Content[]>([])

  useEffect(()=> {
    if(visible && list.length === 0) {
      messageFill().then(({code, data})=> {
        if(code === 0) {
          setList(data as MessageFillResult[])
        }
      })
    }
  }, [visible])

  return (
    <div className="feat-message--quick">
      <button onClick={()=> setVisible(!visible)} type="button" className="quick">常用语</button>
      {visible && <div className="list-wrapper">
          <ul>
            {list.map((t)=> <li onClick={ ()=> {
              props.onConfirm(t.content)
              setVisible(false)
            } } key={t.id}>{t.content}</li>)}
          </ul>
        </div>
      }
    </div>
  )
}

export default Quick